// 논리·추론 영역 (총 20문항)

export const iqLogicQuestions = [
  {
    id: 49,
    category: 'logic',
    question: '빈칸(?)에 들어갈 숫자는?',
    visualType: 'matrix3x3',
    visualData: {
      matrix: [
        ['2', '3', '5'],
        ['3', '4', '7'],
        ['4', '5', '?']
      ]
    },
    options: ['8', '9', '10', '11'],
    answer: 1,
    explanation: '각 행의 첫 두 수를 더하면 세 번째 수가 됩니다. 4 + 5 = 9.',
  },
  {
    id: 50,
    category: 'logic',
    question: '빈칸(?)에 들어갈 숫자는?',
    visualType: 'matrix3x3',
    visualData: {
      matrix: [
        ['3', '4', '12'],
        ['5', '6', '30'],
        ['7', '8', '?']
      ]
    },
    options: ['55', '48', '56', '64'],
    answer: 2,
    explanation: '각 행의 첫 두 수를 곱하면 세 번째 수가 됩니다. 7 × 8 = 56.',
  },
  {
    id: 51,
    category: 'logic',
    question: '빈칸(?)에 들어갈 숫자는?',
    visualType: 'matrix3x3',
    visualData: {
      matrix: [
        ['10', '6', '4'],
        ['9', '5', '4'],
        ['8', '4', '?']
      ]
    },
    options: ['4', '3', '5', '2'],
    answer: 0,
    explanation: '각 행에서 첫 수에서 둘째 수를 빼면 세 번째 수가 됩니다. 8 - 4 = 4.',
  },
  {
    id: 52,
    category: 'logic',
    question: '빈칸(?)에 들어갈 숫자는?',
    visualType: 'matrix3x3',
    visualData: {
      matrix: [
        ['12', '4', '3'],
        ['15', '5', '3'],
        ['18', '6', '?']
      ]
    },
    options: ['2', '4', '3', '6'],
    answer: 2,
    explanation: '각 행에서 첫 수를 둘째 수로 나누면 세 번째 수가 됩니다. 18 ÷ 6 = 3.',
  },
  {
    id: 53,
    category: 'logic',
    question: '빈칸(?)에 들어갈 숫자는?',
    visualType: 'matrix3x3',
    visualData: {
      matrix: [
        ['2', '4', '8'],
        ['3', '9', '27'],
        ['4', '16', '?']
      ]
    },
    options: ['48', '32', '64', '128'],
    answer: 2,
    explanation: '각 행이 n, n², n³으로 구성됩니다. 4³ = 64.',
  },
  {
    id: 54,
    category: 'logic',
    question: '빈칸(?)에 들어갈 숫자는?',
    visualType: 'matrix3x3',
    visualData: {
      matrix: [
        ['2', '4', '16'],
        ['3', '9', '81'],
        ['4', '16', '?']
      ]
    },
    options: ['128', '256', '64', '512'],
    answer: 1,
    explanation: '각 행에서 가운데 수의 제곱이 세 번째 수가 됩니다. 16² = 256.',
  },
  {
    id: 55,
    category: 'logic',
    question: '빈칸(?)에 들어갈 숫자는?',
    visualType: 'matrix3x3',
    visualData: {
      matrix: [
        ['3', '6', '21'],
        ['4', '8', '36'],
        ['5', '10', '?']
      ]
    },
    options: ['50', '60', '55', '45'],
    answer: 2,
    explanation: '각 행에서 첫 수 × 둘째 수 + 첫 수 = 세 번째 수입니다. 5×10+5 = 55.',
  },
  {
    id: 56,
    category: 'logic',
    question: '빈칸(?)에 들어갈 시각(시)은?',
    visualType: 'matrix3x3',
    visualData: {
      matrix: [
        ['3', '6', '9'],
        ['6', '9', '12'],
        ['9', '12', '?']
      ]
    },
    options: ['6', '3', '9', '12'],
    answer: 1,
    explanation: '시계가 3시간씩 전진합니다. 12시에서 3시간 뒤는 3시입니다.',
  },
  {
    id: 57,
    category: 'logic',
    question: '빈칸(?)에 들어갈 숫자는?',
    visualType: 'matrix3x3',
    visualData: {
      matrix: [
        ['4', '3', '5'],
        ['5', '4', '7'],
        ['6', '5', '?']
      ]
    },
    options: ['8', '7', '9', '11'],
    answer: 2,
    explanation: '각 행에서 첫 수 + 둘째 수 - 2 = 세 번째 수입니다. 6 + 5 - 2 = 9.',
  },
  {
    id: 58,
    category: 'logic',
    question: '빈칸(?)에 들어갈 숫자는?',
    visualType: 'matrix3x3',
    visualData: {
      matrix: [
        ['2', '3', '7'],
        ['3', '4', '13'],
        ['4', '5', '?']
      ]
    },
    options: ['20', '19', '21', '22'],
    answer: 2,
    explanation: '각 행에서 첫 수 × 둘째 수 + 1 = 세 번째 수입니다. 4×5+1 = 21.',
  },
  {
    id: 59,
    category: 'logic',
    question: '빈칸(?)에 들어갈 숫자는?',
    visualType: 'matrix4x4',
    visualData: {
      matrix: [
        ['1', '3', '9', '27'],
        ['2', '6', '18', '54'],
        ['3', '9', '27', '81'],
        ['4', '12', '36', '?']
      ]
    },
    options: ['96', '120', '100', '108'],
    answer: 3,
    explanation: '각 행에서 3배씩 증가합니다. 36 × 3 = 108.',
  },
  {
    id: 60,
    category: 'logic',
    question: '빈칸(?)에 들어갈 숫자는?',
    visualType: 'matrix4x4',
    visualData: {
      matrix: [
        ['1', '2', '3', '6'],
        ['2', '3', '4', '9'],
        ['3', '4', '5', '12'],
        ['4', '5', '6', '?']
      ]
    },
    options: ['13', '15', '17', '19'],
    answer: 1,
    explanation: '각 행의 첫 세 수를 더하면 네 번째 수가 됩니다. 4 + 5 + 6 = 15.',
  },
  {
    id: 61,
    category: 'logic',
    question: '빈칸(?)에 들어갈 숫자는?',
    visualType: 'matrix4x4',
    visualData: {
      matrix: [
        ['1', '2', '3', '5'],
        ['2', '3', '4', '10'],
        ['3', '4', '5', '17'],
        ['4', '5', '6', '?']
      ]
    },
    options: ['24', '28', '26', '30'],
    answer: 2,
    explanation: '각 행에서 첫 수 × 둘째 수 + 셋째 수 = 네 번째 수입니다. 4×5+6 = 26.',
  },
  {
    id: 62,
    category: 'logic',
    question: '빈칸(?)에 들어갈 숫자는?',
    visualType: 'matrix4x4',
    visualData: {
      matrix: [
        ['1', '1', '2', '3'],
        ['1', '2', '3', '5'],
        ['2', '3', '5', '8'],
        ['3', '5', '8', '?']
      ]
    },
    options: ['12', '15', '13', '14'],
    answer: 2,
    explanation: '각 행이 앞의 두 수를 더하는 피보나치 수열입니다. 5 + 8 = 13.',
  },
  {
    id: 63,
    category: 'logic',
    question: '빈칸(?)에 들어갈 숫자는?',
    visualType: 'matrix4x4',
    visualData: {
      matrix: [
        ['1', '2', '3', '4'],
        ['2', '3', '4', '1'],
        ['3', '4', '1', '2'],
        ['4', '1', '2', '?']
      ]
    },
    options: ['1', '4', '3', '2'],
    answer: 2,
    explanation: '1부터 4까지의 수가 각 행에서 왼쪽으로 한 칸씩 밀리며 순환합니다. 마지막 칸은 3입니다.',
  },
  {
    id: 64,
    category: 'logic',
    question: '빈칸(?)에 들어갈 숫자는?',
    visualType: 'matrix4x4',
    visualData: {
      matrix: [
        ['2', '4', '6', '8'],
        ['4', '6', '8', '10'],
        ['6', '8', '10', '12'],
        ['8', '10', '12', '?']
      ]
    },
    options: ['12', '16', '14', '18'],
    answer: 2,
    explanation: '각 행과 각 열에서 2씩 증가합니다. 12 + 2 = 14.',
  },
  {
    id: 93,
    category: 'logic',
    question: '1·2행의 규칙을 보고, 빈칸(?)에 들어갈 도형은?',
    visualType: 'compositeMatrix',
    visualData: {
      composites: [
        { frame: 'hexagon', lines: ['/'] }, { frame: 'hexagon', lines: ['\\'] }, { frame: 'hexagon', lines: ['x'] },
        { frame: 'hexagon', lines: ['\\'] }, { frame: 'hexagon', lines: ['x'] }, { frame: 'hexagon', lines: ['/'] },
        { frame: 'hexagon', lines: ['x'] }, { frame: 'hexagon', lines: ['/'] }, null
      ]
    },
    options: ['1', '2', '3', '4', '5', '6', '7', '8'],
    optionVisualType: 'compositeShape',
    optionVisuals: [
      { composite: { frame: 'hexagon', lines: ['\\'] } },
      { composite: { frame: 'hexagon', lines: ['/'] } },
      { composite: { frame: 'hexagon', lines: ['x'] } },
      { composite: { frame: 'hexagon', lines: ['+'] } },
      { composite: { frame: 'circle', lines: ['\\'] } },
      { composite: { frame: 'square', lines: ['\\'] } },
      { composite: { frame: 'hexagon', lines: ['h'] } },
      { composite: { frame: 'hexagon', lines: ['v'] } }
    ],
    answer: 0,
    explanation: '각 행에서 / → \\ → x 순으로 선이 순환합니다. 3행 마지막은 \\ 입니다.',
  },
  {
    id: 94,
    category: 'logic',
    question: '1·2행의 규칙을 보고, 빈칸(?)에 들어갈 도형은?',
    visualType: 'compositeMatrix',
    visualData: {
      composites: [
        { frame: 'circle', lines: ['h'] }, { frame: 'circle', lines: ['h', 'v'] }, { frame: 'circle', lines: ['h', 'v', '/'] },
        { frame: 'circle', lines: ['v'] }, { frame: 'circle', lines: ['v', '\\'] }, { frame: 'circle', lines: ['v', '\\', '/'] },
        { frame: 'circle', lines: ['/'] }, { frame: 'circle', lines: ['/', '\\'] }, null
      ]
    },
    options: ['1', '2', '3', '4', '5', '6', '7', '8'],
    optionVisualType: 'compositeShape',
    optionVisuals: [
      { composite: { frame: 'circle', lines: ['x', 'h'] } },
      { composite: { frame: 'circle', lines: ['x', 'v'] } },
      { composite: { frame: 'circle', lines: ['+', '/'] } },
      { composite: { frame: 'circle', lines: ['+', '\\'] } },
      { composite: { frame: 'square', lines: ['x', 'h'] } },
      { composite: { frame: 'square', lines: ['x', 'v'] } },
      { composite: { frame: 'circle', lines: ['x'] } },
      { composite: { frame: 'circle', lines: ['+'] } }
    ],
    answer: 0,
    explanation: '각 행에서 선의 개수가 1개씩 늘어나며, 기존 선에 새로운 방향의 선이 추가됩니다. 3행 마지막은 /, \\, h 3개의 선이 들어갑니다.',
  },
  {
    id: 95,
    category: 'logic',
    question: '1·2행의 규칙을 보고, 빈칸(?)에 들어갈 도형은?',
    visualType: 'compositeMatrix',
    visualData: {
      composites: [
        { frame: 'square', lines: ['/'] }, { frame: 'square', lines: ['\\'] }, { frame: 'square', lines: ['x'] },
        { frame: 'square', lines: ['\\'] }, { frame: 'square', lines: ['x'] }, { frame: 'square', lines: ['/'] },
        { frame: 'square', lines: ['x'] }, { frame: 'square', lines: ['/'] }, null
      ]
    },
    options: ['1', '2', '3', '4', '5', '6', '7', '8'],
    optionVisualType: 'compositeShape',
    optionVisuals: [
      { composite: { frame: 'square', lines: ['\\'] } },
      { composite: { frame: 'square', lines: ['/'] } },
      { composite: { frame: 'square', lines: ['x'] } },
      { composite: { frame: 'square', lines: ['+'] } },
      { composite: { frame: 'circle', lines: ['\\'] } },
      { composite: { frame: 'circle', lines: ['/'] } },
      { composite: { frame: 'square', lines: ['h'] } },
      { composite: { frame: 'square', lines: ['v'] } }
    ],
    answer: 0,
    explanation: '각 행에서 / → \\ → x 순으로 선이 순환합니다. 3행 마지막은 \\ 입니다.',
  },
  {
    id: 96,
    category: 'logic',
    question: '1·2행의 규칙을 보고, 빈칸(?)에 들어갈 도형은?',
    visualType: 'compositeMatrix',
    visualData: {
      composites: [
        { frame: 'square', lines: ['+'] }, { frame: 'circle', lines: ['+'] }, { frame: 'diamond', lines: ['+'] },
        { frame: 'circle', lines: ['+'] }, { frame: 'diamond', lines: ['+'] }, { frame: 'hexagon', lines: ['+'] },
        { frame: 'diamond', lines: ['+'] }, { frame: 'hexagon', lines: ['+'] }, null
      ]
    },
    options: ['1', '2', '3', '4', '5', '6', '7', '8'],
    optionVisualType: 'compositeShape',
    optionVisuals: [
      { composite: { frame: 'triangle', lines: ['+'] } },
      { composite: { frame: 'pentagon', lines: ['+'] } },
      { composite: { frame: 'square', lines: ['+'] } },
      { composite: { frame: 'circle', lines: ['+'] } },
      { composite: { frame: 'diamond', lines: ['+'] } },
      { composite: { frame: 'hexagon', lines: ['+'] } },
      { composite: { frame: 'triangle', lines: ['x'] } },
      { composite: { frame: 'pentagon', lines: ['x'] } }
    ],
    answer: 0,
    explanation: '선(+)은 고정되고 프레임이 사각→원→마름모→육각→삼각 순으로 순환합니다. 마지막은 삼각 프레임 안에 + 선입니다.',
  },
];